<template>
	<div class="wrapper">
		<div class="wrapper_top">
			<top-info :loanInfo="loan_info" loanColor="white"></top-info>
			<img src="@/assets/image/internal/payment/bkg_line.webp" alt="" class="bkg_line" />
			<div class="container">
				<div class="title">
					<img src="@/assets/image/internal/payment/icon1.webp" alt="" />
					<span>Monto del préstamo: </span>
				</div>
				<div class="number">
					<span>$ </span>
					<span class="big">{{ addComma(value ? value : min_amount) }}</span>
				</div>
				<div v-if="min_amount != max_amount" class="range_init">
					<div class="range">
						<range v-model="value" :min="min_amount" :max="max_amount" :bar-height="12" :step="10000"></range>
					</div>
					<div class="init">
						<span>$ {{ addComma(min_amount) }}</span>
						<span>$ {{ addComma(max_amount) }}</span>
					</div>
				</div>
				<div class="title">
					<img src="@/assets/image/internal/payment/icon2.webp" alt="" />
					<span>Plazo máximo (días)</span>
				</div>
				<div class="bottom_button">
					<div class="button_top" :class="{ button_top_other: product_suitable.length > 3 }">
						<button
							v-for="(item, index) in product_suitable"
							:key="index"
							:class="{ activeColor: active == index }"
							@click="handleTime(item, index)"
						>
							{{ item.max_period }} Días
						</button>
					</div>
					<button class="sumbit" @click="getRiskTokenByConfig">
						Solicitar el préstamo
					</button>
				</div>
			</div>
			<swipe-info :bannerList="bannerList"></swipe-info>
		</div>
	</div>
</template>

<script>
	import common from '@/mixins/common.js'
	import topInfo from '@/components/internal/topInfo.vue'
	import { addComma, getQueryVariable } from '@/utils/internal'
	import swipeInfo from '@/components/internal/swipeInfo.vue'

	// 按需引入部分组件
	import { Range } from 'mint-ui'

	export default {
		mixins: [common],
		components: {
			Range,
			topInfo,
			swipeInfo,
		},
		data() {
			return {
				value: null,
				active: 0,
				product_suitable: [],
				max_amount: 1000, //Maximum amount
				min_amount: 100, //Minimum amount
				max_period: '', //term
				idStr: '',
				bannerList: [],
				loan_info: {},
			}
		},
		mounted() {
			this.getApiHead()
			this.getAccessToken()
			this.refreshPage()
			window.refreshPage = this.refreshPage
			window.callbackRiskToken = this.callbackRiskToken
		},
		methods: {
			addComma,
			getQueryVariable,
			refreshPage() {
				this.getProductList()
				this.getLoanInfo()
				this.getGetBanner({ bannerType: 2 })
			},
			//Obtain product list
			getProductList() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'product/list', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							if (res.data.data.product_suitable) {
								this.product_suitable = res.data.data.product_suitable
								this.max_amount = this.product_suitable[0].max_amount
								this.min_amount = this.product_suitable[0].min_amount
							}
						}
					})
			},
			//Select number of periods
			handleTime(item, value) {
				this.max_period = item.max_period
				this.active = value
				this.value = item.min_amount
				this.product_suitable.forEach((item, index) => {
					if (value == index) {
						this.max_amount = item.max_amount
						this.min_amount = item.min_amount
						this.idStr = item.id_str
					}
				})
			},

			handleBanner(item) {
				window.android.clickBanner(JSON.stringify(item))
			},

			getRiskTokenByConfig() {
				let string = JSON.stringify({
					code: 3,
					smsFlag: 1,
					calendarFlag: 1,
					appListFlag: 1,
					reqPermission: 0,
					locationFlag: 1,
					trace: (Math.floor(Math.random() * 1000000) + 1).toString(),
				})
				window.android?.getRiskTokenByConfig(string)
			},
			callbackRiskToken(node, token, trace) {
				console.log('callbackRiskToken--rescheduleIndex----', node, token, trace)
				this.handleCreateOrder(token)
			},
			//Create temporary order
			handleCreateOrder(token) {
				this.$axios
					.post(this.apiHeadGatewayVh + 'order/create', {
						...this.params,
						tokenKey: token,
						loan: this.value ? this.value : this.min_amount, //Create principal for order
						period: this.max_period || this.product_suitable[0].max_period, //Deadline for creating orders
						product_id: this.idStr || this.product_suitable[0].id_str, //Product ID for creating the order
						app_version: window.android.getAppVersionCode(), //27
					})
					.then((res) => {
						if (res.data.code == 0) {
							//1006 Live failure
							if (res.data.data.current_step == 1006) {
								window.android.gotoAlive()
							} else {
								window.android.openUrl(`${this.url}/calculation`)
								// window.open(`http://localhost:8080/calculation`);
							}
						}
					})
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/rescheduleIndex.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
